<template>
  <div v-if="configError">
    Configurazione wiper non completa
    <div v-if="!libraryWiperConfig.email && useCredentials">
      email wiper non pervenuto alla libreria
    </div>
    <div v-if="!libraryWiperConfig.password && useCredentials">
      password per mail wiper non pervenuto alla libreria
    </div>
    <div v-if="!libraryWiperConfig.basePath">
      base-path api wiper non pervenuto alla libreria
    </div>
    <div v-if="!libraryWiperConfig.surveyId">
      survey-id wiper non pervenuto alla libreria
    </div>
    <div v-if="!libraryWiperConfig.lastSurveyLocalstorageId">
      Last survey id non pervenuto alla libreria 
    </div>
    <div v-if="!libraryWiperConfig.questionarioId">
      questionario id wiper non pervenuto alla libreria
    </div>
    <div v-if="!libraryWiperConfig.tokenId">
      token-id non pervenuto alla libreria
    </div>
    <div v-if="libraryWiperConfig.chiusoPerFerie && (!libraryWiperConfig.urlChiusoPerFerie || !libraryWiperConfig.urlChiusoPerFerie.startsWith('/'))">
      Url chiuso per ferie non pervenuto alla libreria o non corretto
    </div>
  </div>
  <paginaQuestionario :surveyId="$store.state.libraryWiperConfig.surveyId" v-else-if="!authLoading" />
</template>

<script>
import axios from "axios";
import { apiUrls } from "../api/apiUrls";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import PaginaQuestionario from "../components/paginaQuestionario/PaginaQuestionario.vue";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../styles/style.scss"
//import ErroreGenerico from "./components/modalErrors/erroreGenerico/ErroreGenerico.vue"

export default {
  name: "PaginaQuestionarioWrapperWC",
  props: {
    domId: {
      type: String,
      default: null,
    },
    libraryWiperConfig: {
      type: Object,
      default: () => ({
        email: "",
        password: "",
        basePath: "",
        ricordaRisposteQuestionario: true,
        questionarioId: "",
        surveyId: "",
        tokenId: "",
        lastSurveyLocalstorageId: "",
        joomlaArticoloBasePath: "",
        isJoomla5: "",
        joomlaDocumentiUtiliBasePath: "",
        problemiTecniciAnswerId: "",
        abuserAnswerId: "",
        problemiTecniciUrl: "",
        abuserUrl: "",
        chiusoPerFerie: "",
        urlChiusoPerFerie: "",
        chiusoPerFerieDal: "",
        chiusoPerFerieAl: "",
        chiudiInbound: "",
        chiudiInboundDal: "",
        chiudiInboundAl: "",
        minutiTimerInbound: "",
        enableAllegati: "true",
        ufficioAmministrativoId: "6"
      }),
    },
  },
  data: function () {
    return {
      authLoading: true,
      
    };
  },
  components: {
    paginaQuestionario: PaginaQuestionario,
    //'erroreGenerico': ErroreGenerico
  },
  computed: {
    useCredentials: function () {
      if(process.env.VUE_APP_USE_CREDENTIALS === "true"){
        return true
      }else{
        return false
      }
    },
    configError: function () {
      

      if (
        !this.$props.libraryWiperConfig ||
        (!this.$props.libraryWiperConfig.email && process.env.VUE_APP_USE_CREDENTIALS === "true") ||
        (!this.$props.libraryWiperConfig.password && process.env.VUE_APP_USE_CREDENTIALS  === "true") ||
        !this.$props.libraryWiperConfig.basePath ||
        (this.$props.libraryWiperConfig.chiusoPerFerie &&  (!this.$props.libraryWiperConfig.urlChiusoPerFerie || !this.$props.libraryWiperConfig.urlChiusoPerFerie.startsWith('/') ) ) ||
        (!this.$props.libraryWiperConfig.tokenId && !process.env.VUE_APP_TOKEN_ID) ||
        !this.$props.libraryWiperConfig.lastSurveyLocalstorageId ||
        !this.$props.libraryWiperConfig.surveyId ||
        !this.$props.libraryWiperConfig.tokenId ||
        !this.$props.libraryWiperConfig.questionarioId
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  mounted() {
    if(this.libraryWiperConfig){
      this.$store.commit("setLibraryWiperConfig", this.libraryWiperConfig);
    }

    
    axios.interceptors.request.use(
      (config) => {
        let basePath = this.libraryWiperConfig.basePath;
        config.baseURL = basePath;
        //config.url = basePath + config.url;
        let tokenId = this.libraryWiperConfig.tokenId || process.env.VUE_APP_TOKEN_ID;

        const token = localStorage.getItem(tokenId);

        if (token) {
          config.headers["Authorization"] = "Bearer " + token;
        }

        config.headers["Content-Type"] = "application/json";
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        /* if(process.env.MIX_ADD_BACKSLASH_AXIOS_URL){
            config.url = config.url + '/'
        } */
        return config;
      },
      (error) => {
        Promise.reject(error);
      }
    );
    
    

    if (
      this.libraryWiperConfig
    ) {
      if(process.env.VUE_CHECK_USER_LOGIN === "true"){
        this.$store.dispatch("CHECK_USER_ALREADY_LOGGED");
      }
      

      if (!this.$store.state.userIsLoggedIn) {
        let email = this.libraryWiperConfig.email;
        let password = this.libraryWiperConfig.password;
        let tokenId = this.libraryWiperConfig.tokenId || process.env.VUE_APP_TOKEN_ID;
        let payloadLogin = {}
        if(process.env.VUE_APP_USE_CREDENTIALS === "true"){
          payloadLogin = {
              email: email,
              password: password,
            }
        }

        
          axios
            .post("a", payloadLogin)
            .then((response) => {
              if (response.data && response.data.k) {
                localStorage.setItem(tokenId, response.data.k);

                this.$store.commit("login");
                response.data &&
                  response.data.user &&
                  localStorage.setItem("last_user_id", response.data.user.id);
                response.data &&
                  response.data.user &&
                  this.$store.commit("setUserData", response.data.user);
              }
              this.authLoading = false
            })
            .catch((error) => {
              this.authLoading = false
              this.$store.commit("logout");
            });
        
      } else {
        this.authLoading = false
        axios
          .get(apiUrls["user_detail"] + localStorage.getItem("last_user_id"))
          .then((response) => {
            if (response.data) {
              this.$store.commit("setUserData", response.data);
            }
          })
          .catch((error) => {
            this.$store.commit("logout");
          });
      }
    }
  },
};
</script>
